import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Mariana Silva',
      role: 'Diretora de Eventos - TechCorp',
      text: 'A ACJ superou todas as nossas expectativas. O painel de LED ficou impecável na nossa convenção anual. A equipe técnica foi extremamente profissional e pontual. Já fechamos contrato para os próximos 3 eventos.',
      rating: 5,
      initials: 'MS'
    },
    {
      name: 'Ricardo Oliveira',
      role: 'Produtor Musical',
      text: 'Trabalhamos com a ACJ em mais de 20 shows e a qualidade é sempre excepcional. Os telões de LED fazem toda a diferença na experiência do público. Equipe confiável e equipamentos de primeira.',
      rating: 5,
      initials: 'RO'
    },
    {
      name: 'Ana Beatriz Costa',
      role: 'Cerimonialista',
      text: 'Indico a ACJ para todos os meus clientes de casamento. O painel de LED transforma completamente a decoração. O atendimento é impecável desde o primeiro contato até a desmontagem.',
      rating: 5,
      initials: 'AC'
    },
    {
      name: 'Pastor Eduardo Mendes',
      role: 'Igreja Nova Vida - BH',
      text: 'O telão de LED transformou completamente a experiência dos nossos cultos. A congregação se sente mais conectada e o visual das conferências ficou profissional. Equipe pontual e respeitosa.',
      rating: 5,
      initials: 'EM'
    },
    {
      name: 'Fernanda Lopes',
      role: 'Gerente de Marketing - Shopping Boulevard',
      text: 'Instalamos painéis de LED em áreas estratégicas do shopping e o retorno dos lojistas foi imediato. A qualidade da imagem e o suporte técnico da ACJ são impecáveis.',
      rating: 5,
      initials: 'FL'
    }
  ];

  return (
    <section className="testimonials" id="depoimentos">
      <div className="section-container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-label">Depoimentos</span>
          <h2>O que nossos <span>clientes dizem</span></h2>
          <p>A satisfação dos nossos clientes é a melhor prova da qualidade do nosso trabalho.</p>
        </div>

        <div className="testimonials__grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonials__card glass-card" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="testimonials__stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="fas fa-star"></i>
                ))}
              </div>
              <p className="testimonials__text">"{testimonial.text}"</p>
              <div className="testimonials__author">
                <div className="testimonials__avatar">
                  {testimonial.initials}
                </div>
                <div>
                  <h4>{testimonial.name}</h4>
                  <span>{testimonial.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
